import React from 'react';

import { Row, Col, Button, Layout, Modal, Breadcrumb, Select } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import TablaStock from './TablaStock';

import getStockPorOrganismo from '../../../graphql/querys/ventas/getStockPorOrganismo.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

import { imprimirReporteStock } from '../../common/funciones/imprimirReporte';

@compose(
  graphql(getUsuario, {
    name: 'usuario',
  }),
  graphql(getOrganismos)
)
class VerStock extends React.Component {
  state = {
    tipo_sellos: [],
    llamada: false,
    fechaInicio: '',
    fechaFin: '',
    idOrganismo: '',
    step: 0,
  };

  onSubmit = e => {
    e.preventDefault();
    // console.log(e);
    this.buscar();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.usuario &&
      nextProps.usuario.getUsuario &&
      !this.state.llamada
    ) {
      this.cambiarOrganismo(nextProps.usuario.getUsuario.organismo._id);
    }
  }

  cambiarOrganismo = idOrganismo => {
    this.setState(
      {
        ...this.state,
        idOrganismo: idOrganismo,
      },
      () => {
        this.props.client
          .query({
            query: getStockPorOrganismo,
            variables: { idOrganismo: idOrganismo },
            fetchPolicy: 'network-only',
          })
          .then(res => {
            const stock = res.data.getStockPorOrganismo;
            // console.log('Respuesta exitosa!');
            // console.log(stock);

            let val = [];
            if (stock) {
              _.each(stock.detalle, tipo => {
                // console.log('LALA');
                // console.log(tipo);
                let a = _.find(tipo.tipo_sello.limites, elem => {
                  return elem.organismo._id == idOrganismo;
                });

                if (tipo.cantidad > 0) {
                  val.push({ ...tipo, limite: a ? a.limite : '-' });
                }
              });
            }

            let valores = _.orderBy(val, ['tipo_sello[valor]'], ['asc']);

            this.setState({
              ...this.state,
              llamada: true,
              tipo_sellos: valores,
            });
          })
          .catch(err => {
            console.log('Error en la creacion');
            console.log(err);

            Modal.error({
              title: 'Error a la hora de buscar el stock en la base de datos',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo ? (nombre = organismo.nombre) : (nombre = '');
    return nombre;
  };

  render() {
    let usuario = this.props.usuario;
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');

    const { data } = this.props;
    if (data.loading || !usuario.getUsuario) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Stock</Breadcrumb.Item>
          <Breadcrumb.Item>Consultar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <div>
            <h1 style={{ textAlign: 'center', marginTop: 15 }}>
              Administración General
            </h1>
            <h2 style={{ textAlign: 'center', marginTop: 40 }}>STOCK ACTUAL</h2>
            <h3 style={{ textAlign: 'center', marginTop: 20 }}>
              ORGANISMO:
              <Select
                style={{ width: 500, marginLeft: 10 }}
                id="organismos"
                placeholder="Seleccione el organismo"
                defaultValue={usuario.getUsuario.organismo._id}
                disabled={usuario.getUsuario.organismo._id != '00004'}
                onSelect={valor => this.cambiarOrganismo(valor)}
              >
                {this.props.data.getOrganismos &&
                  this.props.data.getOrganismos.map(organismo => (
                    <Select.Option key={organismo._id}>
                      {organismo.nombre}
                    </Select.Option>
                  ))}
              </Select>
            </h3>

            <h5 style={{ textAlign: 'center', marginTop: 20 }}>
              FECHA DE GENERACION: {fGeneracion}
            </h5>

            <TablaStock
              tipo_sellos={this.state.tipo_sellos}
              organismo={this.state.idOrganismo}
            />

            <Row>
              <Col span={8} offset={8}>
                <Button
                  type="primary"
                  style={{ marginTop: 20, marginLeft: '33%' }}
                  onClick={() =>
                    imprimirReporteStock(
                      this.obtenerNombreOrganismo(this.state.idOrganismo),
                      fGeneracion,
                      this.state.tipo_sellos
                    )
                  }
                >
                  Imprimir Datos
                </Button>
              </Col>
            </Row>
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(VerStock);
